$.fn.scrollspy = function (params) {

    var items = $(this);
    var activeClass = 'active';

    var that = this;

    that.processSpy = function () {

        if(!items.length){
            return;
        }

        var viewportTop = $(window).scrollTop();
        var viewportHeight = $(window).height();
        var viewportBottom = viewportTop + viewportHeight;

        var found = false;

        items.each(function () {

            if (found) {
                return false;
            }

            var link = $(this);
            var target = link.attr('href');
            var el = $(target);

            if (!el.length) {
                return;
            }

            var elTop = el.offset().top;
            var elHeight = el.outerHeight();
            var elBottom = elTop + elHeight;

            if (viewportHeight > elHeight) {
                if (elTop >= viewportTop && elBottom <= viewportBottom) {
                    that.makeActive(link);
                    found = true;
                }
            } else {
                if (elTop >= viewportTop && elTop <= viewportHeight / 2 + viewportTop) {
                    that.makeActive(link);
                    found = true;
                }
            }
        });
    };

    that.makeActive = function (el) {
        if (!el.hasClass(activeClass)) {
            items.removeClass(activeClass);
            el.addClass(activeClass);
            // console.log('adding class ' + activeClass + ' to ' + el.attr('href'));
        }
    };

    that.processSpy();

    document.addEventListener('scroll', that.processSpy, {passive: true});
    //$(window).on('scroll', that.processSpy);

};